export const IS_REQ = 'is required';
export const NUMERIC_REGEX_ERR_TXT = 'should be a numeric value';

export const getRequiredError = (label) => `${label} ${IS_REQ}`;
export const getMaxError = (label, limit) => `${label} cannot be greater than ${limit} characters`;
export const getMinError = (label, limit) => `${label} cannot be less than ${limit} characters`;

export const REQUIRED_ERROR = (label) => getRequiredError(label);
export const MAX_ERROR = (label, limit) => getMaxError(label, limit);
export const MIN_ERROR = (label, limit) => getMinError(label, limit);

export const NUMERIC_REGEX_ERROR = (label) => `${label} ${NUMERIC_REGEX_ERR_TXT}`;

export const CTC_NAME_REGEX_ERROR = (label) => `${label} can be alphanumeric and optionally contain special characters in between. Valid characters include ., ,, -, _, or space`;
export const USER_IDENTIFIER_REGEX_ERR = 'User ID can be any ASCII character excluding space and colon';
export const PHONE_NO_REGEX_ERR = 'Phone Number can be numeric and optionally include \'-\' , \'(\' , \')\' , \'+\' , \'space\', \'/\', in between';
export const PHONE_NO_REGEX_END_ERR = 'Phone Number should end with number or number followed by \')\'';
export const PHONE_NO_REGEX_ALLOWED_ERR = 'Phone Number can be numeric and optionally include \'+\' , \'(\' , \')\' , \'/\' , \'-\'  ';

export const CREDENTIAL_PASSWORD_COMMON_REGEX_ERR = 'This is a common password and cannot be used';
export const CREDENTIAL_PASSWORD_REGEX_ERR = 'Password must not contain whitespace at the beginning or at the end';

export const PASSWORD_REGEX_ERR = 'Password must contain 4 out of 4 of the following: uppercase, lowercase, number, special character.Valid characters include A-Z, a-z, 0-9 ,!, @, # ,$ ,%,* _, -,^';
export const PASSWORD_COMMON_REGEX_ERR = 'This is a common password and cannot be used';
export const PASSWORD_NOT_MATCH_ERR = 'Passwords must match';

export const TERMS_OF_USE_ERR = 'Must agree to terms of use';

export const OTP_LIMIT_ERROR = 'OTP should be a 6-digit code';

export const SECURITY_PIN_LIMIT_ERROR = 'Security Pin should be between 6 to 9 digits';
